import React, {Component, useCallback, useEffect} from 'react';
import {Button, Col, Container, Row} from 'reactstrap';
import PageMeta from 'components/PageMeta';
import BackgroundImageTextSection from 'components/BackgroundImageTextSection';
import Video from 'components/Video';
import CheckoutButton from 'components/CheckoutButton';
import Footer from 'components/Footer';
import logoTrees from 'static/logo/logo-trees-for-future-white.png';
import wlcLogo from 'static/logo/frn-wlc-logo.svg';

import {WlcUpsell} from 'components/SalesCta';
import Section, {SectionImage} from 'components/Elements/Section';
import useBeacon from 'utils/useBeacon';
import IconList, {IconListItem} from 'components/Elements/IconList';

export default function () {
  useBeacon();
  return (
    <div className="page page-nosocial">
      <PageMeta title="WLC Upsell" description="WLC upsell page" />

      <div className="page-content">
        <Section className="section-wlc-header" innerClass="text-white text-center pt-4" color="black">
          <Container>
            <Row className="d-flex justify-content-center mb-4">
              <Col sm="9" lg="12">
                <p className="m-0">
                  <em>Now, here’s one last exclusive offer ONLY for Impact Kit owners (like you!)…</em>
                </p>
              </Col>
            </Row>

            <Row className="d-flex justify-content-center">
              <Col lg="10" className="video-col px-0 px-sm-3">
                <Video url="https://www.youtube.com/watch?v=MYbcMCV49f8" playing />
              </Col>
            </Row>
          </Container>
        </Section>

        <Section className="section-wlc-info" color="white">
          <Container>
            <Row>
              <Col>
                <p className="text-center">
                  <strong>If you want</strong> to put what you learn in the Impact Kit into action,{' '}
                  <br className="d-none d-sm-block d-lg-none" />
                  for <strong>lasting results,</strong> <br className="d-none d-lg-block" />
                  WHOLE Life Club is for you. (And only right now, <br className="d-none d-sm-block d-lg-none" />
                  you can <strong>get 3 months for free!</strong>)
                </p>
              </Col>
            </Row>
            <Row className="d-flex justify-content-center">
              <Col md="10" lg="8" xl="6">
                <img src={wlcLogo} />
              </Col>
            </Row>
            <Row>
              <Col className="text-center">
                <p>
                  <em>This offer won’t be available to you again after you close this page. </em>
                </p>
              </Col>
            </Row>
          </Container>
        </Section>

        <SectionImage
          id="section-wlc-ignite"
          innerClass="pt-lg-0"
          imgPosition="right"
          color="white"
          imgUrl={require('static/backgrounds/1186912068.jpg')}
        >
          <h3 className="section-heading">
            The Impact Kit will give you the inspiration you need to take action for your health and the health of the
            planet.
          </h3>
          <h4 className="text-400 mt-0">And WHOLE Life Club is the perfect next step!</h4>
          <p>
            Imagine being able to steadily improve your planet-friendly and healthy living lifestyle. Imagine having
            expert guidance to help you enjoy clarity and confidence about the real impact of your food choices, and
            savoring delightful, mouthwatering, and nourishing new recipes. Imagine sharing your food revolution journey
            with friends and allies for your WHOLE Life.
          </p>
          <p>
            <strong>
              WHOLE Life club will provide a sustained wind for your sails, helping you commit to applying the
              breakthroughs you learn from the Impact Kit so they become the sustainability-supporting and
              health-boosting path of a lifetime.
            </strong>
          </p>
          <p>
            When you join <strong>now,</strong> you’ll get a{' '}
            <em>special opportunity ONLY for Empowerment Package owners — and ONLY available from this page.</em>{' '}
            <strong>Get 3 months of WHOLE Life Club for FREE!</strong>
          </p>
          <p>
            After three months, you’ll be auto-billed for $19/month (a 33% discount off the regular $29/month rate). And
            if you don’t LOVE it, you can cancel any time during the three-month trial, and you’ll never be charged a
            penny.
          </p>
        </SectionImage>

        <Section id="section-wlc-offer" innerClass="text-white text-center" color="gradient-indigo-purple-right">
          <Container>
            <Row>
              <Col>
                <WlcUpsell
                  offerBoxBackground="offer-box-dark"
                  offerBoxBorder="offer-box-borderless"
                  offerBoxPadding="px-3 px-sm-4 px-md-5"
                  noTrees
                />
              </Col>
            </Row>
          </Container>
        </Section>

        <div className="d-none d-lg-block">
          <Section id="section-wlc-join-a" color="white">
            <Container>
              <Row>
                <Col>
                  <h2 className="section-only-heading text-center">Here’s What You’ll Get When You Join...</h2>
                </Col>
              </Row>
            </Container>
          </Section>
        </div>

        <SectionImage
          id="section-wlc-join-b"
          imgPosition="right"
          color="white"
          imgUrl={require('static/backgrounds/1127348018.jpg')}
        >
          <h2 className="section-heading d-lg-none">
            Here’s What You’ll Get <br className="d-none d-sm-block" />
            When You Join...
          </h2>
          <h3 className="section-heading">Wisdom</h3>
          <h4 className="text-400 mt-0">
            “Knowledge you can use, from experts <br className="d-none d-xl-block" />
            you can trust.”
          </h4>
          <IconList>
            <IconListItem>
              <strong>WHOLE Life Action Hours every month</strong> with top health revolutionaries (including
              opportunities to share your opinions and <em>ask YOUR questions</em>). Plus, downloadable MP3s and
              transcripts.
            </IconListItem>
            <IconListItem>
              <strong>Action of the Week videos, with Action Checklists,</strong> so you can keep making easy and steady
              progress towards your health and sustainability goals. (52 new fun videos every year!)
            </IconListItem>
          </IconList>
        </SectionImage>

        <SectionImage
          id="section-wlc-join-c"
          imgPosition="left"
          color="light-gray"
          imgUrl={require('static/backgrounds/beet-burgers-4.jpg')}
        >
          <h3 className="section-heading">Recipes</h3>
          <h4 className="text-400 mt-0">“Love foods that love you back.”</h4>
          <IconList>
            <IconListItem>
              <strong>A new set of 5 delicious, whole-foods, plant-powered recipes every week</strong> that are
              nutritious, affordable, easy-to-prepare, and taste amazing.
            </IconListItem>
            <IconListItem>
              Tips and tricks to help you <strong>make healthy eating simple and efficient.</strong>
            </IconListItem>
          </IconList>
        </SectionImage>

        <SectionImage
          id="section-wlc-join-d"
          imgPosition="right"
          color="white"
          imgUrl={require('static/backgrounds/847978026.jpg')}
        >
          <h3 className="section-heading">Community</h3>
          <h4 className="text-400 mt-0">“Be a part of the WHOLE.”</h4>
          <IconList>
            <IconListItem>
              <strong>Join with health-minded people</strong> to share insights, receive guidance, spread the food
              revolution, build connections, and achieve your lifestyle goals.
            </IconListItem>
            <IconListItem>
              <strong>Use the moderated forum</strong> (on our custom platform — which is 100% Facebook-free) to ask
              your questions and get real, trustworthy answers. You can start and join in conversations on topics that
              matter to you, and connect with peers who share your values and concerns.
            </IconListItem>
          </IconList>
          <p>
            <strong>
              <em>
                Plus our entire library including hundreds of tasty recipes, inspiring Action of the Week videos, and
                informative WHOLE Life Action Hour videos — all yours instantly.
              </em>
            </strong>
          </p>
        </SectionImage>

        <section className="section-wlc-offer background-gradient-indigo-purple-right">
          <div className="section-inner">
            <Container>
              <Row>
                <Col>
                  <WlcUpsell />
                </Col>
              </Row>
            </Container>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}
